export default __webpack_public_path__ + "static/2020 StM Annual Report-1821b746f1dabdd337dd6a4a1987eb06.pdf";